import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';

export const CloseBtn: React.FC<{ onClick?: Function }> = React.memo(({ onClick }) => {
    return (
        <div
            className="c-navigation-modal-close"
            onClick={() => {
                onClick?.();
            }}
        >
            <IconFont name="CrossBlack" color="var(--base-naturaldark70)" fontSize={10} />
        </div>
    );
});
